// Shamelessly inspired by from https://github.com/cristianbote/react-hashtag

import { createElement, Fragment } from 'react'
import { shape, string } from 'prop-types'

const HASHTAG_REGEX = /([#|＃][^\s]+)/g

export const parse = (value, hashtagStyle = {}) =>
  value.split(HASHTAG_REGEX).map((chunk) => {
    if (chunk.match(HASHTAG_REGEX)) {
      return createElement(
        'span',
        {
          key: `${chunk}-${Math.random()}`,
          className: 'bzfy-u-text-bold',
          style: hashtagStyle,
        },
        chunk,
      )
    }

    return chunk
  })

export default function HashtagRenderer({ text, hashtagStyle }) {
  if (!text) return null
  return createElement(Fragment, null, parse(text, hashtagStyle))
}

HashtagRenderer.propTypes = {
  hashtagStyle: shape(),
  text: string.isRequired,
}
